module.exports = __webpack_public_path__ + "img/sharepageimg.c633ca3f.svg";